"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var shared_1 = require("mad-utils/lib/shared");
var javelin_exports_1 = require("../javelin-exports");
/********************************* EXPORT DATA WITH TYPES APPLIED *********************************/
exports.Dose = javelin_exports_1.javelin.data.model.user.Dose;
exports.Dose_init_base = javelin_exports_1.javelin.data.model.user.Dose_init_base;
exports.Dose_init_db = javelin_exports_1.javelin.data.model.user.Dose_init_db;
exports.Dose_init_generated = javelin_exports_1.javelin.data.model.user.Dose_init_generated;
// Add other constructors to main Dose object/constructor
shared_1.defineProp(exports.Dose, "Dose_init_base", exports.Dose_init_base);
shared_1.defineProp(exports.Dose, "Dose_init_db", exports.Dose_init_db);
shared_1.defineProp(exports.Dose, "Dose_init_generated", exports.Dose_init_generated);
/********************************* REFERENCE PROPS FOR DEBUGGING **********************************/
// SET CLASS NAME
shared_1.defineProp(exports.Dose.prototype, "JVLN_CLASS_NAME", "Dose", false);
shared_1.defineProp(exports.Dose_init_db.prototype, "JVLN_CLASS_NAME", "Dose", false);
shared_1.defineProp(exports.Dose_init_generated.prototype, "JVLN_CLASS_NAME", "Dose", false);
//# sourceMappingURL=dose.js.map